import React from 'react';
import PropTypes from 'prop-types';
import GenericButton from './GenericButton';
import { copyContent } from '../../util/CommonUtils';
import { filterLabel } from '../../util/CrosstabUtils';

const renderText = (selectedGridData, selectedGrid, index) => {
  let gridTitle = '';
  if (selectedGridData && selectedGridData.objectsAdded) {
    const objectsAdded = selectedGridData.objectsAdded;
    if (objectsAdded.length > 0 && objectsAdded.length === 1) {
      if (objectsAdded[0].breadcrumbs !== objectsAdded[0].keyword) {
        gridTitle = objectsAdded[0].dataSmartSearchObjectsCreated ?
          objectsAdded[0].breadcrumbs :
          filterLabel(`${objectsAdded[0].shortTextCatgView}`, `${objectsAdded[0].breadcrumbs}`);
      } else {
        gridTitle = `${objectsAdded[0].shortText} `;
      }
    } else {
      gridTitle = '';
      objectsAdded.forEach(item => {
        let textValue = '';
        if (item.breadcrumbs && item.breadcrumbs !== item.keyword) {
          textValue = item.dataSmartSearchObjectsCreated
            ? item.breadcrumbs
            : filterLabel(`${item.shortTextCatgView}`, `${item.breadcrumbs}`);
        } else if (!item.isLabelUpdated && item.objectType === 'operator') {
          textValue = `${textValue} ${item.shortText} `;
        } else if (item.breadcrumbs === item.keyword) {
          textValue = `${textValue} ${item.shortText}`
        }
        gridTitle += textValue;
      });
    }
  } else if (selectedGrid.selectedNames && selectedGrid.selectedNames[index]) {
    gridTitle = `${selectedGrid.selectedNames[index]}`;
  }
  return gridTitle;
};

const renderCopyData = (gridTitle, selectedGrid) => {
  if (selectedGrid.selectedKeywords.length > 0) {
    return `${gridTitle} [${
      selectedGrid.selectedKeywords.length
    }]:\r\n${
      gridTitle === 'Bases'
      ? selectedGrid.selectedKeywords.map((selectedKeyword, index) =>
          `${selectedGrid.selectedNames[index]}`,
      ) : selectedGrid.dataSmartSearch.map((data, index) => 
        `${renderText(data, selectedGrid, index)}`
      )
      .join('\r\n')}\r\n`;
  }
  return '';
};


const renderData = (gridTitle, selectedGrid) => {
  if (selectedGrid.selectedKeywords.length > 0) {
    return (
      <div>
        <h4>
          <b>{`${gridTitle} [${selectedGrid.selectedKeywords.length}]`}:</b>
        </h4>
        {gridTitle === 'Bases'
          ? selectedGrid.selectedKeywords.map((selectedKeyword, index) => (
            <div className='invalidGridData'
             key={selectedKeyword}
             title={`${selectedKeyword} - ${
              selectedGrid.selectedNames[index]
              }`}
             >{`${selectedKeyword} - ${
              selectedGrid.selectedNames[index]
              }`}</div>
          ))
          : selectedGrid.dataSmartSearch.map((data, index) => (
            <div className='invalidGridData'
             key={selectedGrid.selectedKeywords[index]}
             title={renderText(data, selectedGrid, index)}>
               {renderText(data, selectedGrid, index)}</div>
          ))
        }
      </div>
    );
  }

  return <div />;
};

const ValidateStudyModal = props => (
  <div>
    <div className="row margin-0">
      <div className="large-10 columns">
        <h4>The following items are not available in the current study:</h4>
      </div>
      <div className="large-2 columns">
        <GenericButton
          name="copy"
          onBtnClick={props.dataScreen !== 'DataHaul' ? () =>
            copyContent(
              `The following items are not available in the current study:\n\nStudy Name: ${
                props.moduleStudy.sd
              }\n\n${renderCopyData(
                'Columns',
                props.invalidData.columnsGrid,
              )}\n${renderCopyData(
                'Rows',
                props.invalidData.rowsGrid,
              )}\n${renderCopyData(
                'Bases',
                props.invalidData.basesGrid,
              )}`,
            ) :
            () => copyContent(
              `The following items are not available in the current study:\n\nStudy Name: ${
                props.moduleStudy.sd
              }\n\n${renderCopyData(
                'Columns',
                props.invalidData.datahaulColumnsGrid,
              )}\n${renderCopyData(
                'Bases',
                props.invalidData.datahaulBasesGrid,
              )}`,
            )
          }
        />
      </div>
    </div>
    <div className="row">
      <h4>
        <b className="padding-20">{`Study Name: ${
          props.moduleStudy.sd
        }`}</b>
      </h4>
    </div>
    <div className="row" />
    <div className="row invalid-grid-data">
      {props.dataScreen === undefined &&
        renderData('Columns', props.invalidData.columnsGrid)}
      {props.dataScreen &&
        props.dataScreen === 'DataHaul' &&
        renderData('Columns', props.invalidData.datahaulColumnsGrid)}
      {props.dataScreen !== undefined &&
        props.dataScreen === 'VisaHaul' &&
        renderData('Target', props.invalidData.columnsGrid)}
      {renderData('Rows', props.invalidData.rowsGrid)}
      {props.dataScreen === undefined &&
        renderData('Bases', props.invalidData.basesGrid)}
      {props.dataScreen &&
        props.dataScreen === 'DataHaul' &&
        renderData('Bases', props.invalidData.datahaulBasesGrid)}
    </div>
    <div className="modal-footer">
      <GenericButton
        name="OK"
        btnStyle="button btn-cncl float-right"
        onBtnClick={() => props.handleParentHide()}
      />
    </div>
  </div>
);

ValidateStudyModal.propTypes = {
  handleParentHide: PropTypes.func,
  moduleStudy: PropTypes.shape({
    sd: PropTypes.string,
  }),
  invalidData: PropTypes.shape({
    columnsGrid: PropTypes.shape({}),
    rowsGrid: PropTypes.shape({}),
    basesGrid: PropTypes.shape({}),
    datahaulColumnsGrid: PropTypes.shape({}),
    datahaulBasesGrid: PropTypes.shape({}),
  }),
  dataScreen: PropTypes.string,
};

export default ValidateStudyModal;
